import { BaseEventEntryTypeDto } from "./BaseEventEntryTypeDto";

export class TicketTypeDto extends BaseEventEntryTypeDto {
    price: number = 0;
}